import { useState } from "react";
import { ArrowUp, Paperclip } from "lucide-react";
import { cn } from "@/lib/utils";

export default function Composer({ agent, onSend, disabled }) {
  const [text, setText] = useState("");

  const submit = (e) => {
    e?.preventDefault?.();
    if (!text.trim() || disabled) return;
    onSend?.(text);
    setText("");
  };

  return (
    <form
      data-testid="composer-form"
      onSubmit={submit}
      className="card-soft flex w-full items-center gap-2 rounded-full p-1.5 pl-5"
    >
      <button
        type="button"
        data-testid="composer-attach"
        className="flex h-8 w-8 items-center justify-center rounded-full text-zinc-400 transition-colors hover:bg-zinc-100 hover:text-zinc-700"
        aria-label="Attach"
      >
        <Paperclip className="h-4 w-4" strokeWidth={2.2} />
      </button>
      <input
        data-testid="composer-input"
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder={`Message ${agent.name}...`}
        disabled={disabled}
        className="flex-1 bg-transparent py-2 text-[14px] text-zinc-900 placeholder:text-zinc-400 focus:outline-none disabled:opacity-60"
      />
      <button
        type="submit"
        data-testid="composer-send"
        disabled={!text.trim() || disabled}
        className={cn(
          "flex h-9 w-9 items-center justify-center rounded-full bg-black text-white transition-all",
          "hover:bg-zinc-800 disabled:cursor-not-allowed disabled:opacity-30",
        )}
        aria-label="Send"
      >
        <ArrowUp className="h-4 w-4" strokeWidth={2.6} />
      </button>
    </form>
  );
}
